




















import { Component, Vue, Prop } from "vue-property-decorator";
import router from "@/router/router";

import store from "@/store";
import { Section } from "@/common/interface";
import { Getter, Action } from "vuex-class";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import CourseIntro from "./CourseIntro.vue";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivityLimit from "./ActivityLimit.vue";
import ActivityDistributeMode from "./ActivityDistributeMode.vue";
import ActivityRewardSetting from "./ActivityRewardSetting.vue";

@Component({
  components: {
    "activity-label": ActivityLabel,
    "dash-line": DashLine,
    "activity-limit": ActivityLimit,
    "activity-distribute-mode": ActivityDistributeMode,
    "activity-reward-setting": ActivityRewardSetting,
  },
})
export default class ActivityChoise extends Vue {}
